export default "__VITE_ASSET__$Dg$i5bt__"